import { IEditorV3 } from "@azu-business/editor-v3";
import axios from "axios";
import { processAxiosError } from "../processAxiosError";
import { ICommentReturn } from "./addComment";

/**
 * Request body used when updating a comment's content.
 */
export interface CommentUpdateDto {
  content: IEditorV3;
}

/**
 * Details required to update a hierarchy comment.
 */
export interface UpdateHierarchyCommentDetails extends CommentUpdateDto {
  hierarchyId: string;
  commentId: string;
}

/**
 * Details required to update a TLF item comment.
 */
export interface UpdateTlfItemCommentDetails extends CommentUpdateDto {
  id: string;
  azsolId: string;
  version: number;
  commentId: string;
}

/**
 * Update the content of a comment on a hierarchy or TLF item.
 *
 * @param backEndUrl - Base backend URL
 * @param details - Details containing updated content and identifiers
 * @param controller - AbortController to cancel the request
 * @returns The updated comment wrapped in ICommentReturn
 */
export const updateComment = async (
  backEndUrl: string,
  details: UpdateHierarchyCommentDetails | UpdateTlfItemCommentDetails,
  controller: AbortController,
): Promise<ICommentReturn> => {
  try {
    if ((details as UpdateHierarchyCommentDetails).hierarchyId) {
      const hdets = details as UpdateHierarchyCommentDetails;
      const url = `${backEndUrl}Hierarchy/${hdets.hierarchyId}/Comment/${hdets.commentId}`;
      const ret = await axios.put(url, { content: details.content }, { signal: controller.signal });
      return { success: true, data: ret.data };
    } else {
      const tdets = details as UpdateTlfItemCommentDetails;
      const url = `${backEndUrl}TlfItems/${tdets.id}/Comment/${tdets.commentId}`;
      const ret = await axios.put(url, { content: details.content }, { signal: controller.signal });
      return { success: true, data: ret.data };
    }
  } catch (error) {
    return processAxiosError("Update comment failed", error);
  }
};
